// src/components/UnidadeOrganica/UnidadeOrganicaDetails.jsx
import React, { useEffect, useState } from 'react';
import { obterUnidadeOrganica } from '../../services/unidadeOrganicaService';
import { useParams } from 'react-router-dom';

const UnidadeOrganicaDetails = () => {
    const { id } = useParams();
    const [unidade, setUnidade] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await obterUnidadeOrganica(id);
            setUnidade(response.data);
        };
        fetchData();
    }, [id]);

    if (!unidade) return <p>Carregando...</p>;

    return (
        <div>
            <h2>{unidade.nome}</h2>
            <p>Tipo: {unidade.tipo}</p>
            <p>Data de Início: {unidade.data_inicio}</p>
        </div>
    );
};

export default UnidadeOrganicaDetails;